import * as React from 'react';

export const useErrorBoundary = () => {
  const [error, setError] = React.useState<boolean>(false);
  if (error) {
    throw new Error();
  }
  return { triggerBoundary: () => setError(true) };
};
